import * as noUiSlider from 'nouislider';
import * as wNumb from 'wnumb';
import {PageName} from './constants';

const containers = {
  flats: {
    floor: document.getElementById(`floor-range`),
    square: document.getElementById(`square-range`),
    rooms: document.getElementById(`rooms-range`)
  }
};
const ranges = {
  flats: [
    {
      container: containers.flats.floor,
      options: {
        start: [0, 4],
        connect: [false, true, false],
        behaviour: "tap",
        step: 1,
        range: {
          'min': [0],
          'max': [4]
        },
        tooltips: [ wNumb({ decimals: 0 }), wNumb({ decimals: 0 })]
      }
    },
    {
      container: containers.flats.square,
      options: {
        start: [0, 502.0],
        connect: [false, true, false],
        behaviour: "tap",
        step: 0.1,
        range: {
          'min': [0],
          'max': [502.0]
        },
        tooltips: [ wNumb({ decimals: 1 }), wNumb({ decimals: 1 })]
      }
    },
    {
      container: containers.flats.rooms,
      options: {
        start: [0, 3],
        connect: [false, true, false],
        behaviour: "tap",
        step: 1,
        range: {
          'min': [0],
          'max': [3]
        },
        tooltips: [ wNumb({ decimals: 0 }), wNumb({ decimals: 0 })]
      }
    }
  ]
};
let initializedRanges = {};

const getRangeFiltersTypes = (containerName, cb) => {
  const ranges = containers[containerName];

  for (let range in ranges) {
    const current = ranges[range];

    current.noUiSlider.on('change.one', () => {
      const values = current.noUiSlider.get().map(Number);

      cb(current.dataset.filter, values);
    });
  }
};

export const clearRanges = (page) => {
  const currentRanges = initializedRanges[page];

  for (let range = 0; range < currentRanges.length; range++) {
    currentRanges[range].reset();
  }
};

export default (page, cb) => {
  const currentRanges = ranges[page];

  initializedRanges[page] = [];

  currentRanges.forEach(({container, options}) => {
    noUiSlider.create(container, options);
    initializedRanges[page].push(container.noUiSlider);
  });

  getRangeFiltersTypes(PageName.FLATS, cb);
};
